import { render, staticRenderFns } from "./PinButton.vue?vue&type=template&id=ddbb25ce&scoped=true"
import script from "./PinButton.vue?vue&type=script&lang=js"
export * from "./PinButton.vue?vue&type=script&lang=js"
import style0 from "./PinButton.vue?vue&type=style&index=0&id=ddbb25ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbb25ce",
  null
  
)

export default component.exports